<template>
  <div class="menu-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewFleetLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal modern-modal--md">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p v-if="editMode" class="modern-modal__subtitle">
                Update the menu configuration below, then choose Update to apply changes.
              </p>
              <p v-else class="modern-modal__subtitle">
                Fill out the form to create a new menu entry for your application.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <form class="modal-form" @submit.prevent>
                <div class="modal-columns">
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                    <label class="vs-input--label">Parent<sup>*</sup></label>
                    <v-select
                      style="background: white"
                      @input="(x) => (parent_id = x.value)"
                      :clearable="false"
                      :value="getSelectValue(parent_id, parent_array)"
                      :reduce="(text) => text.value"
                      label="text"
                      :options="parent_array" />
                  </div>
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                    <label class="vs-input--label">Menu Name<sup>*</sup></label>
                    <div class="vs-con-input">
                      <input
                        type="text"
                        v-model="menu_name"
                        name="menu_name"
                        class="vs-inputx vs-input--input normal" />
                    </div>
                    <span></span>
                  </div>
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                    <label class="vs-input--label">Menu Icon<sup>*</sup></label>
                    <div class="vs-con-input">
                      <input
                        type="text"
                        v-model="menu_icon"
                        name="menu_icon"
                        class="vs-inputx vs-input--input normal" />
                    </div>
                    <span></span>
                  </div>
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                    <label class="vs-input--label">Menu Link<sup>*</sup></label>
                    <div class="vs-con-input">
                      <input
                        type="text"
                        v-model="menu_link"
                        name="menu_link"
                        class="vs-inputx vs-input--input normal" />
                    </div>
                    <span></span>
                  </div>
                </div>
              </form>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
              @click="submitForm"
              v-if="!editMode">
              Submit
            </vs-button>
            <vs-button
              class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
              @click="updateForm"
              v-if="editMode">
              Update
            </vs-button>
            <vs-button
              color="danger"
              class="mr-3 mb-2 btn-load-3 vs-con-loading__container"
              @click="deleteData"
              v-if="editMode">
              Delete
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="closeForm">
              Cancel
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewFleet: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  watch: {
    level(val) {
      if (parseInt(val) > 1) {
        this.calculateLevel()
      } else {
        this.parent_id = ''
        this.parent_array = []
      }
    },
    addNewFleetLocal(va) {
      if (this.addNewFleet && !this.editMode) {
        this.calculateLevel()
        // this.menu_name = this.dataEdit.menu_name;
        // this.menu_icon = this.dataEdit.menu_icon;
        // this.menu_link = this.dataEdit.menu_link;
        // this.calculateLevel();
        // this.parent_id = this.dataEdit.parent_id;
        // if(this.dataEdit.parent_id){
        //     this.parent_id = this.dataEdit.parent_id;
        // }else{
        //     this.parent_id = '';
        // }
      }
    },
    editMode(val) {
      if (val) {
        if (this.addNewFleet && this.editMode) {
          this.menu_name = this.dataEdit.menu_name
          this.menu_icon = this.dataEdit.menu_icon
          this.menu_link = this.dataEdit.menu_link
          this.calculateLevel()
          if (this.dataEdit.parent_id) {
            this.parent_id = this.dataEdit.parent_id
          } else {
            this.parent_id = ''
          }
        }
      } else {
        this.clearFields()
      }
    },
  },
  computed: {
    addNewFleetLocal: {
      get() {
        let isOpen = false
        if (typeof this.addNewFleet === 'string') {
          const normalized = this.addNewFleet.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.addNewFleet)
            } catch (e) {
              isOpen = !!this.addNewFleet
            }
          }
        } else {
          isOpen = !!this.addNewFleet
        }

        if (isOpen) {
          this.calculateLevel()
          if (this.editMode) {
            this.menu_name = this.dataEdit.menu_name
            this.menu_icon = this.dataEdit.menu_icon
            this.menu_link = this.dataEdit.menu_link
            this.parent_id = this.dataEdit.parent_id || ''
          } else {
            this.clearFields()
          }
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      parent_array: [],
      name: '',
      parent_id: '',
      menu_name: '',
      menu_icon: '',
      menu_link: '',
      status: 1,
      parent: '',
      level: 1,
    }
  },
  methods: {
    calculateLevel() {
      this.parent_array = []
      this.parent = ''
      this.parent_array.push({
        text: '- No Parent -',
        value: '',
      })
      this.allData.forEach((x) => {
        if (!x.parent_id) {
          this.parent_array.push({
            text: x.menu_name,
            value: x.id,
          })
        }
      })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.menu_name = ''
      this.menu_icon = ''
      this.menu_link = ''
      this.parent_id = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let dataForm = {
        menu_name: this.menu_name,
        menu_icon: this.menu_icon,
        menu_link: this.menu_link,
        parent_id: this.parent_id,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postMenu(dataForm)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteMenu(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        menu_name: this.menu_name,
        menu_icon: this.menu_icon,
        menu_link: this.menu_link,
        parent_id: this.parent_id,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.updateMenu(dataForm, this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>
<style>
sup {
  color: red;
}

#content-area.content-area-default .menu-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .menu-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .menu-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .menu-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .menu-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.menu-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(620px, 94vw);
  max-height: 82vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 28px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #64748b;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(82vh - 170px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 28px 24px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modal-columns {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field-group--stacked {
  white-space: normal;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.field-group span {
  display: none;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-inputx.vs-input--input.normal {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.94rem;
  line-height: 1.5;
  color: #0f172a;
}

.field-group .vs-inputx.vs-input--input.normal:focus {
  box-shadow: none;
}

.field-group ::v-deep(.vs__dropdown-toggle) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  padding: 6px 14px;
  min-height: 44px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.field-group ::v-deep(.vs__dropdown-toggle:focus),
.field-group ::v-deep(.vs__dropdown-toggle.vs__dropdown-toggle--focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__dropdown-menu) {
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  margin-top: 6px;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

@media (max-width: 640px) {
  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modern-modal {
    width: min(520px, 94vw);
  }
}
</style>
